import { getFtwPhones } from "../modules/home/selectors";
import {shallowEqual, useSelector} from 'react-redux';
import { Phone } from "@zetti/zweb-repository";

const useGetFtwPhones = (): Phone[] => {
  return useSelector(getFtwPhones, shallowEqual);
};

export default useGetFtwPhones